/* eslint-disable arrow-parens */
/* eslint-disable */
import React, { useState, useCallback, useEffect, useContext, Suspense, useRef } from "react";
import SelectedEmployeeGrid from "./SelectedEmployeeGrid";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { AuthContext, GroupContext, UIContext } from "../../../../../contexts";
import DateFnsUtils from "@date-io/date-fns";
import "date-fns";

import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";

import { Grid, Button, Paper, Tooltip, Chip, Checkbox, CheckboxProps } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { withStyles, makeStyles } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { openEnrollmentBulkUploadTemplateFile } from "../../../../../assets";

import EventIcon from "@material-ui/icons/Event";
import AddIcon from "@material-ui/icons/Add";
import InfoIcon from "@material-ui/icons/Info";
import SendIcon from "@material-ui/icons/Send";

import "./openEnrollment.css";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Member } from "../../../../../@types/member.types";
import { Plan, PlanPopOverContent, PlanStatus } from "../../../../../@types/plan.types";
import { api } from "../../../../../utils/api";
import {
	AllVEBOpenEnrollmentPayload,
	OpenEnrollmentType,
	SpecificVEBOpenEnrollmentPayload,
	VEBOpenEnrollmentInput,
	VEBOpenEnrollmentSchema,
	VerifyBulkOpenEnrollmentPayload
} from "../../../../../@types/openEnrollment.types";
import { EmployeWithVEBOpenEnrollmentQuery } from "../../../../../utils/api/openEnrollment/openEnrollment";
import Autocomplete from "react-autocomplete";
import { read, utils } from "xlsx";
import { LazyOpenedEnrollmentAlertDialog } from "../../..";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { useNavigate } from "react-router-dom";
import { Validation } from "../../../../../@types/validation.types";
import { trackPromise } from "react-promise-tracker";
import { getPermissionsFromGroupOwner } from "../../../../../utils/getPermissionsFromGroupOwner";

const Alert = (props: AlertProps) => {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const VEBOpenEnrollment = () => {
	const [openEnrollment, setOpenEnrollment] = useState<VEBOpenEnrollmentInput>();
	const [isYearlyOpenEnrollment, setIsYearlyOpenEnrollment] = useState(false);
	const [openOpenedEnrollmentAlertDialog, setOpenOpenedEnrollmentAlertDialog] = useState(false);
	const [openedEnrollmentEmployees, setOpenedEnrollmentEmployees] = useState<VEBOpenEnrollmentSchema[]>([]);
	const [hasVerifiedBulkOpenEnrollmentFile, setHasVerifiedBulkOpenEnrollmentFile] = useState(false);
	const [employees, setEmployees] = useState<Member[]>([]);
	const [bulkOpenEnrollmentFile, setBulkOpenEnrollmentFile] = useState<File | null>(null);
	const [selectedEmployees, setSelectedEmployees] = useState<Member[]>([]);
	const [validEmployees, setValidEmployees] = useState<Member[]>([]);
	const [invalidEmployeeMemberIDs, setInvalidEmployeeMemberIDs] = useState<string[]>([]);
	const [validMemberSSNs, setValidMemberSSNs] = useState<string[]>([]);
	const navigate = useNavigate();
	const queryGroupNumber = useRouteParam("gn");
	const { setDashboardHeader } = useContext(UIContext);
	const [searchMemberIdQuery, setSearchMemberIdQuery] = useState<string>("");
	const [searchFirstNameQuery, setSearchFirstNameQuery] = useState<string>("");
	const [searchLastNameQuery, setSearchLastNameQuery] = useState<string>("");
	const [searchSSNQuery, setSearchSSNQuery] = useState<string>("");
	const { currentGroup, setCurrentGroup } = useContext(GroupContext);
	const [validation, setValidation] = useState<Validation>({
		openEnrollment: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();

	const { user, setUser } = useContext(AuthContext);

	const vebOpenEnrollmentPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.plan_control_menu.veb_open_enrollment_sub.self
		: null;

	const handleOpenEnrollmentChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement | { name?: string | undefined; value: unknown }>) => {
			const { name, value } = event.target as HTMLInputElement;
			let field;
			// console.log("name", name, value);

			if (value === "ALL" || value === "BULK" || value === "SPECIFIC") {
				field = "type";
				setOpenEnrollment(Object.assign({}, openEnrollment, { [field]: value }));
			} else {
				setOpenEnrollment(Object.assign({}, openEnrollment, { [name]: value }));
			}
		},
		[openEnrollment]
	);

	const handleOpenYearlyEnrollmentClick = () => {
		setIsYearlyOpenEnrollment((prevState) => !prevState);
	};

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			openEnrollment: {},
			status: "invalid"
		};
		let flag = true;

		if (openEnrollment === undefined) {
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (openEnrollment?.type === undefined) {
			_validation.current.openEnrollment["type"] = "Assignment Type is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (openEnrollment?.start_date === undefined || openEnrollment?.start_date === "") {
			_validation.current.openEnrollment["start_date"] = "Start date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (openEnrollment?.end_date === undefined || openEnrollment?.end_date === "") {
			_validation.current.openEnrollment["end_date"] = "End date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (String(openEnrollment?.end_date).length !== 0) {
			const endDate = new Date(openEnrollment?.end_date as any).getTime();
			// console.log(endDate);
			const startDate = new Date(openEnrollment?.start_date as any).getTime();
			// console.log(startDate);
			if (endDate < startDate) {
				// console.log("In the if");
				_validation.current.openEnrollment["end_date"] = "End Date cannot be less than start date";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current.status;
	}, [openEnrollment, validation]);

	// console.log("Validation", validation);

	const handleDeleteBulkOpenEnrollmentFile = useCallback(() => {
		setBulkOpenEnrollmentFile(null);
		setHasVerifiedBulkOpenEnrollmentFile(false);
	}, []);

	const handleBulkOpenEnrollmentFileUpload = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target;
			if (!(files && files[0])) {
				return;
			}
			const _enrolledFile = {
				...openEnrollment,
				enrolled_file: files[0],
				filename: files[0].name
			};
			setBulkOpenEnrollmentFile(files[0]);
			event.target.value = "";
		},
		[openEnrollment]
	);

	// const handleDateChange = useCallback(
	// 	(_date: MaterialUiPickersDate, name: string) => {
	// 		// console.log("Name", name);
	// 		const date = new Date(_date as any);
	// 		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
	// 		setOpenEnrollment(Object.assign({}, openEnrollment, { [name]: parsedDate }));
	// 	},
	// 	[openEnrollment]
	// );

	const handleDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const parsedDate = _date as unknown as string;
			setOpenEnrollment(Object.assign({}, openEnrollment, { [name]: parsedDate }));
		},
		[openEnrollment]
	);

	const handleSearchEmployeeChange = useCallback(
		async (
			// eslint-disable-next-line @typescript-eslint/ban-types
			event: React.ChangeEvent<HTMLInputElement>,
			field: string
		) => {
			if (!openEnrollment?.start_date) {
				alert("Please enter start date");
				return;
			}
			if (!openEnrollment?.end_date) {
				alert("Please enter end date");
				return;
			}
			const { value } = event.target;
			if (field === "member_id") {
				setSearchMemberIdQuery(value);
			} else if (field === "first_name") {
				setSearchFirstNameQuery(value);
			} else if (field === "last_name") {
				setSearchLastNameQuery(value);
			} else if (field === "SSN") {
				setSearchSSNQuery(value);
			}
			if (value === "" || value === null) {
				setEmployees([]);
				return;
			}
			if (openEnrollment === undefined) {
				return;
			}
			const employeeWithOpenEnrollmentQuery: EmployeWithVEBOpenEnrollmentQuery = {
				field,
				query: value,
				page: "1",
				limit: "10000",
				start_date: openEnrollment.start_date,
				end_date: openEnrollment.end_date
			};
			const _employees: Member[] = await trackPromise(
				api.openEnrollment.getEmployeeWithVEBOpenEnrollmentStartWith(
					employeeWithOpenEnrollmentQuery,
					queryGroupNumber as number
				)
			);
			// console.log("_employees", _employees);
			if (_employees) {
				setEmployees(Object.assign([], [..._employees]));
			} else {
				setEmployees([]);
			}
		},
		[openEnrollment, queryGroupNumber]
	);

	const handleSelectSearchedEmployee = useCallback(
		(value: string, _selectedEmployee: Member & { open_enrollment: any }) => {
			if (_selectedEmployee.open_enrollment) {
				alert("Enrollment already opened for employee");
				return;
			}
			// console.log("selectedEmployee", _selectedEmployee);
			// console.log("selectedEmployees", selectedEmployees);
			let isEmployeeSelected = false;
			for (let employeeIdx = 0; employeeIdx < selectedEmployees.length; employeeIdx++) {
				const { SSN } = selectedEmployees[employeeIdx];
				if (SSN === _selectedEmployee.SSN) {
					isEmployeeSelected = true;
					break;
				}
			}
			if (isEmployeeSelected === false) {
				setSelectedEmployees((prevSelectedEmployees: Member[]) => {
					return Object.assign([], [...prevSelectedEmployees, _selectedEmployee]);
				});
			}
		},
		[selectedEmployees]
	);

	function stripTime(date: Date): Date {
		return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}

	const handleOpenEnrollmentSubmitClick = useCallback(async () => {
		const validation = await handleValidation();
		if (validation === "valid" && openEnrollment && queryGroupNumber) {
			// console.log(openEnrollment);
			const { type, start_date, end_date } = openEnrollment;

			const startDate = new Date(start_date);
			const endDate = new Date(end_date);

			if (type && start_date && end_date) {
				switch (type) {
					case "ALL": {
						if (stripTime(endDate) <= stripTime(startDate)) {
							alert("End date must be greater than start date.");
							break;
						}
						const allOpenEnrollmentPayload: AllVEBOpenEnrollmentPayload = {
							start_date:
								startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
							end_date: endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
							type: null,
							is_yearlyopenenrollment: isYearlyOpenEnrollment,
							group_number: queryGroupNumber as number
						};
						const openEnrollment = await trackPromise(
							api.openEnrollment.allVEBOpenEnrollment(allOpenEnrollmentPayload)
						);
						// console.log("openEnrollment", openEnrollment);
						if (openEnrollment.status === true) {
							alert("VEB Open Enrollment Successfully done!");
							const pathname = `/employer/all-VEB-enrollments?gn=${queryGroupNumber}`;
							navigate(pathname);
						} else {
							// console.log("openEnrollment.result", openEnrollment.result);
							setOpenedEnrollmentEmployees(
								Object.assign([], openEnrollment.result.VEBOpenEnrollmentEmployees)
							);
							setOpenOpenedEnrollmentAlertDialog(true);
						}
						break;
					}
					case "SPECIFIC": {
						if (stripTime(endDate) <= stripTime(startDate)) {
							alert("End date must be greater than start date.");
							break;
						}
						const allOpenEnrollmentPayload: AllVEBOpenEnrollmentPayload & {
							open_enrollment_for: OpenEnrollmentType;
						} = {
							start_date:
								startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
							end_date: endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
							type: isYearlyOpenEnrollment ? "YEARLY" : null,
							open_enrollment_for: "SPECIFIC",
							group_number: queryGroupNumber as number,
							is_yearlyopenenrollment: isYearlyOpenEnrollment
							// is_yearlyopenenrollment: isYearlyOpenEnrollment
						};
						const specificOpenEnrollmentPayload: SpecificVEBOpenEnrollmentPayload = {
							open_enrollment: allOpenEnrollmentPayload,
							employee_SSNs: selectedEmployees.map(({ SSN }: Member) => SSN)
						};
						const openEnrollment = await trackPromise(
							api.openEnrollment.specificVEBOpenEnrollment(specificOpenEnrollmentPayload)
						);
						// console.log("Response Check---->>", openEnrollment);
						// console.log("openEnrollment", openEnrollment);
						if (openEnrollment.status === true) {
							// console.log("openEnrollment", openEnrollment);
							alert("VEB Open Enrollment Successfully done!");
							const pathname = `/employer/all-VEB-enrollments?gn=${queryGroupNumber}`;
							navigate(pathname);
						} else {
							// console.log("openEnrollment.result", openEnrollment.result);
							setOpenedEnrollmentEmployees(
								Object.assign([], openEnrollment.result.VEBOpenEnrollmentEmployees)
							);
							setOpenOpenedEnrollmentAlertDialog(true);

							if (openEnrollment.errorMessage) {
								alert(openEnrollment.errorMessage);
							}
						}

						// if (openEnrollment.status === true) {
						// 	alert("VEB Open Enrollment Successfully done!");
						// } else {
						// 	if (openEnrollment.errorMessage) {
						// 		alert(openEnrollment.errorMessage);
						// 	}
						// }
						break;
					}
					case "BULK": {
						if (stripTime(endDate) <= stripTime(startDate)) {
							alert("End date must be greater than start date.");
							break;
						}
						const allOpenEnrollmentPayload: AllVEBOpenEnrollmentPayload & {
							open_enrollment_for: OpenEnrollmentType;
						} = {
							start_date:
								startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
							end_date: endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
							open_enrollment_for: "BULK",
							type: isYearlyOpenEnrollment ? "YEARLY" : null,
							group_number: queryGroupNumber as number,
							is_yearlyopenenrollment: isYearlyOpenEnrollment
						};
						const specificOpenEnrollmentPayload: SpecificVEBOpenEnrollmentPayload = {
							open_enrollment: allOpenEnrollmentPayload,
							employee_SSNs: validMemberSSNs
						};
						const openEnrollment = await trackPromise(
							api.openEnrollment.specificVEBOpenEnrollment(specificOpenEnrollmentPayload)
						);
						if (openEnrollment.status === true) {
							alert("VEB Open Enrollment Successfully done!");
							const pathname = `/employer/all-VEB-enrollments?gn=${queryGroupNumber}`;
							navigate(pathname);
						} else {
							// console.log("openEnrollment.result", openEnrollment.result);
							setOpenedEnrollmentEmployees(
								Object.assign([], openEnrollment.result.VEBOpenEnrollmentEmployees)
							);
							setOpenOpenedEnrollmentAlertDialog(true);
						}
						break;
					}
				}
			}
		}
	}, [navigate, openEnrollment, queryGroupNumber, selectedEmployees, validMemberSSNs, handleValidation]);

	const handleVerifyBulkOpenEnrollmentFileClick = useCallback(async () => {
		if (bulkOpenEnrollmentFile === null) {
			alert("Please Upload Bulk Open Enrollment File");
			return;
		}
		const fileReader = new FileReader();
		fileReader.onload = async function (e) {
			if (e?.target === null) {
				return;
			}
			const data = e.target.result;
			const workbook = read(e.target.result);
			// console.log("workbook", workbook);
			const sheet2JsonData = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
				header: ["employee_id"]
			});
			const employeeIDs: string[] = sheet2JsonData.map((value: any, index: number) => {
				// console.log("value", value.employee_id.toString());
				return value.employee_id.toString();
			});
			employeeIDs.shift();
			const verifyBulkOpenEnrollmentPayload: VerifyBulkOpenEnrollmentPayload = {
				employee_IDs: employeeIDs
				// is_yearlyopenenrollment: isYearlyOpenEnrollment
			};
			console.log("bulkupload---->>", verifyBulkOpenEnrollmentPayload);
			const validEmployees = await trackPromise(
				api.openEnrollment.verifyBulkOpenEnrollment(verifyBulkOpenEnrollmentPayload)
			);
			const _validEmployeeMemberIDs: string[] = [];
			const _validMemberSSNs: string[] = [];
			for (let employeeIdx = 0; employeeIdx < validEmployees.length; employeeIdx++) {
				const { member_id, SSN } = validEmployees[employeeIdx];
				_validEmployeeMemberIDs.push(member_id as string);
				_validMemberSSNs.push(SSN);
			}

			const _invalidEmployeeMemberIDs = employeeIDs.filter(
				(employeeID) => _validEmployeeMemberIDs.indexOf(employeeID) < 0
			);
			setValidMemberSSNs(Object.assign([], _validMemberSSNs));
			setInvalidEmployeeMemberIDs(Object.assign([], _invalidEmployeeMemberIDs));
			setValidEmployees(Object.assign([], validEmployees));
			setHasVerifiedBulkOpenEnrollmentFile(true);
		};
		fileReader.readAsArrayBuffer(bulkOpenEnrollmentFile);
	}, [bulkOpenEnrollmentFile]);

	useEffect(() => {
		if (queryGroupNumber) {
			const fetchGroup = async () => {
				try {
					const group = await api.group.getGroupByGroupNumber(queryGroupNumber as number);
					setCurrentGroup(group);
				} catch (error) {
					console.error("Error fetching group:", error);
				}
			};

			fetchGroup();
		}
	}, [queryGroupNumber, setCurrentGroup]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.VEB_open_enrollment);
	}, [setDashboardHeader]);

	return (
		<>
			{
				<Suspense fallback={<div />}>
					<LazyOpenedEnrollmentAlertDialog
						openOpenedEnrollmentAlertDialog={openOpenedEnrollmentAlertDialog}
						setOpenOpenedEnrollmentAlertDialog={setOpenOpenedEnrollmentAlertDialog}
						openedEnrollmentEmployees={openedEnrollmentEmployees}
					/>
				</Suspense>
			}
			<div className="open-enrollment-container" id="open-enrollment-container">
				<Grid container spacing={1} className="pf-grid-container ">
					<div className="pf-title">VEB Open Enrollment for Employees</div>
					<Paper className="pf-paper-container " elevation={3} variant="outlined">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Assigned To</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="assigned-value-container">
									<span className="enroll-check-label">
										<GreenCheckbox
											name="type"
											value="ALL"
											onChange={handleOpenEnrollmentChange}
											checked={openEnrollment?.type === "ALL" ? true : false}
										/>
										<label htmlFor="all" className="pf-label-text ">
											All
										</label>
									</span>
									<span className="enroll-check-label">
										<GreenCheckbox
											name="type"
											value="BULK"
											onChange={handleOpenEnrollmentChange}
											checked={openEnrollment?.type === "BULK" ? true : false}
										/>
										<label htmlFor="bulk" className="pf-label-text assigned-label">
											Bulk
										</label>
									</span>
									<span className="enroll-check-label">
										<GreenCheckbox
											name="type"
											value="SPECIFIC"
											onChange={handleOpenEnrollmentChange}
											checked={openEnrollment?.type === "SPECIFIC" ? true : false}
										/>
										<label
											htmlFor="specific"
											className="pf-label-text "
											style={{ textAlign: "center" }}
										>
											Specific
										</label>
									</span>
								</Grid>
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									{validation?.openEnrollment?.type ? (
										<div className="details">
											<span className="select-validation-text2">
												{validation.openEnrollment.type}
											</span>
										</div>
									) : null}
								</Grid>
							</Grid>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Yearly Open Enrollent</div>
								</Grid>
								<span className="enroll-check-label">
									<GreenCheckbox
										name="type"
										value={isYearlyOpenEnrollment}
										onChange={handleOpenYearlyEnrollmentClick}
										checked={isYearlyOpenEnrollment}
									/>
									<label htmlFor="all" className="pf-label-text ">
										Yes
									</label>
								</span>
							</Grid>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Start Date</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<KeyboardDatePicker
											className="from-date-input"
											id="from-date-input"
											inputVariant="outlined"
											label="Start date"
											placeholder="Enter Start Date"
											name="start_date"
											format="MM/dd/yyyy"
											error={false}
											value={openEnrollment?.start_date ? openEnrollment.start_date : ""}
											onChange={(date) => handleDateChange(date, "start_date")}
											InputProps={{
												readOnly: true
											}}
											InputLabelProps={{
												shrink: true
											}}
											keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
											KeyboardButtonProps={{
												"aria-label": "change date"
											}}
											style={{
												pointerEvents: "unset",
												width: "340px",
												borderRadius: 50
											}}
											helperText={validation.openEnrollment.start_date}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
							</Grid>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">End Date</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<KeyboardDatePicker
											className="from-date-input"
											id="from-date-input"
											inputVariant="outlined"
											label="End Date"
											placeholder="Enter End Date"
											name="end_date"
											format="MM/dd/yyyy"
											error={false}
											value={openEnrollment?.end_date ? openEnrollment.end_date : ""}
											onChange={(date) => handleDateChange(date, "end_date")}
											InputProps={{
												readOnly: true
											}}
											InputLabelProps={{
												shrink: true
											}}
											keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
											KeyboardButtonProps={{
												"aria-label": "change date"
											}}
											style={{
												pointerEvents: "unset",
												width: "340px",
												borderRadius: 50
											}}
											helperText={validation.openEnrollment.end_date}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				{openEnrollment?.type === "BULK" ? (
					<div className="bulk-upload-container">
						<Grid container spacing={1} className="pf-grid-container ">
							<div className="pf-title">Bulk Upload</div>
							<Paper className="pf-paper-container " elevation={3} variant="outlined">
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Upload File</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											{bulkOpenEnrollmentFile === null ? (
												<>
													<input
														className={"document-upload"}
														id={"document-upload"}
														name="enrolled_file"
														type="file"
														onChange={handleBulkOpenEnrollmentFileUpload}
														style={{ display: "none" }}
														accept=".xlsx, .csv"
													/>
													<label htmlFor={"document-upload"}>
														<Button
															className="button enrollment-upload-btn"
															component="span"
															variant="contained"
															style={{
																backgroundColor: "#3A4652",
																color: "#ffff",
																width: 210
															}}
														>
															<span
																className="button-label-with-icon"
																style={{ color: "#ffff" }}
															>
																Add Excel/CSV
															</span>
															<span>
																<AddIcon
																	className="button-icon"
																	style={{ color: "#ffff" }}
																/>
															</span>
														</Button>
													</label>
												</>
											) : (
												<Tooltip title={"Click to download"} arrow>
													<Chip
														label={
															bulkOpenEnrollmentFile
																? shortenFileName(bulkOpenEnrollmentFile.name)
																: "No files added"
														}
														onDelete={() => handleDeleteBulkOpenEnrollmentFile()}
														onClick={() => downloadFile(bulkOpenEnrollmentFile)}
													/>
												</Tooltip>
											)}
											<span className="demo-file-label">
												<a
													href={openEnrollmentBulkUploadTemplateFile}
													download="Bulk Upload Sample"
												>
													(Download Template File)
												</a>
											</span>
										</Grid>
										{bulkOpenEnrollmentFile !== null &&
										hasVerifiedBulkOpenEnrollmentFile === true ? (
											<>
												{invalidEmployeeMemberIDs.length > 0 ? (
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Alert severity="warning" className="bulk-upld-alert-container">
															<div className="error-display-container">
																This is an error message. The following employees are
																invalid.
															</div>
															<div className="emp-id-display-container">
																{invalidEmployeeMemberIDs.map((memberID, index) => {
																	return (
																		<div key={index}>Employee Id - {memberID}</div>
																	);
																})}
															</div>
														</Alert>
													</Grid>
												) : null}
												<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
													<SelectedEmployeeGrid
														selectedEmployees={validEmployees}
														type={"BULK"}
														setSelectedEmployees={setValidEmployees}
													/>
												</Grid>
											</>
										) : null}
									</Grid>
								</Grid>
							</Paper>
						</Grid>
					</div>
				) : null}
				{openEnrollment?.type === "SPECIFIC" ? (
					<div className="specific-add-employees-container">
						<Grid container spacing={1} className="pf-grid-container">
							<div className="pf-title">Add Employee</div>
							<Paper className="pf-paper-container " elevation={3} variant="outlined">
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Search by Employee ID</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "member_id")
													}
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.first_name}
													onSelect={handleSelectSearchedEmployee}
													items={employees}
													value={searchMemberIdQuery}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Search by Employee First Name</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "first_name")
													}
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													onSelect={handleSelectSearchedEmployee}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.first_name}
													//clearOnBlur
													items={employees}
													value={searchFirstNameQuery}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="pf-label-text">Search by Employee Last Name</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "last_name")
													}
													onSelect={handleSelectSearchedEmployee}
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.last_name}
													//clearOnBlur
													items={employees}
													value={searchLastNameQuery}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1} className="pf-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											{/* <div className="pf-label-text">Search by Employee ALT-ID</div> */}
											<div className="pf-label-text">
												Search by Employee{" "}
												{currentGroup?.SSN_provided_by_group ? "SSN" : "ALT-ID"}
											</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
											<div className="auto-complete">
												<Autocomplete
													onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														handleSearchEmployeeChange(event, "SSN")
													}
													onSelect={handleSelectSearchedEmployee}
													menuStyle={{
														maxHeight: "200px",
														overflowX: "hidden",
														scrollBehavior: "smooth",
														zIndex: 1,
														border: "1px solid #ccc",
														borderRadius: "4px",
														boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
													}}
													//inputValue={"hi"}
													getItemValue={(item: Member) => item.SSN}
													//clearOnBlur
													items={employees}
													value={searchSSNQuery}
													renderItem={(
														employee: Member & { open_enrollment: any },
														isHighlighted: boolean
													) => {
														return (
															<div
																className={
																	employee.open_enrollment
																		? "opened-option"
																		: isHighlighted
																		? "highlighted-option option"
																		: "option"
																}
															>{`${employee.first_name} ${employee.last_name} ${
																employee.open_enrollment ? "(Opened)" : ""
															}`}</div>
														);
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								{selectedEmployees.length > 0 ? (
									<SelectedEmployeeGrid
										selectedEmployees={selectedEmployees}
										setSelectedEmployees={setSelectedEmployees}
										type="SPECIFIC"
									/>
								) : null}
							</Paper>
						</Grid>
					</div>
				) : null}
				{vebOpenEnrollmentPermission && vebOpenEnrollmentPermission.update && (
					<div className="pf-action-button-container enroll-action-btn">
						<Button
							className="button-green"
							variant="contained"
							onClick={
								openEnrollment?.type === "BULK" && hasVerifiedBulkOpenEnrollmentFile === false
									? handleVerifyBulkOpenEnrollmentFileClick
									: handleOpenEnrollmentSubmitClick
							}
						>
							<span className="button-label-with-icon">
								{openEnrollment?.type === "BULK" && hasVerifiedBulkOpenEnrollmentFile === false
									? "Verify"
									: "Submit"}
							</span>
							<span>
								<SendIcon className="button-icon" />
							</span>
						</Button>
					</div>
				)}
			</div>
		</>
	);
};

export default VEBOpenEnrollment;
